module.exports = __webpack_public_path__ + "img/end.66f56c38.png";